import React from 'react';
import { Image } from 'react-datocms';
import { MediumHeading } from '@/components/Views/Heading';
import NormalText from '@/components/Views/Text';

interface Props {
    heading?: string;
    featuredImage?: any;
}

/* shared */
const TwoCol = ({ heading, featuredImage }: Props) => {
    /*<div className='default-px default-py w-full relative py-2 px-14 bg-white '>*/
    return (
        <div className='default-px default-py w-full relative'>
            <div className='default-max-w flex flex-col lg:flex-row gap-6 mx-auto my-0 items-center'>
                <div className='w-full z-20 relative'>
                    <MediumHeading heading={heading} className='text-center md:text-left' />
                    {/*<h5 className='font-medium font-Inter text-center sm:text-left text-[#18181B] text-2xl lg:text-3xl mt-0'>{heading}</h5>*/}
                    {/*
                    <NormalText className='font-lg font-light text-left font-Inter w-full mx-auto leading-[1.5]'>
                        In a study conducted by independent researchers with 270 middle school students,
                        <span className='font-bold'>Muzology improved math performance for 99% of students in just 4 weeks.</span> 87% of students improved
                        their initial math scores by 50 points or more.
                    </NormalText>
                    */}
                    <NormalText className='mb-0'>
                        In a study conducted by independent researchers with 270 middle school students,
                        <span className='font-bold'> Muzology improved math performance for 99% of students in just 4 weeks.</span> Eighty-seven percent (87%) of students improved
                        their initial math scores by 50 points or more.
                        <br />
                        <br />
                        Across a series of studies, Muzology continues to drive increased and sustained learning gains for students throughout the country.
                    </NormalText>
                    {/*
                    <p className='font-lg  text-[#4B5563] font-light text-left font-Inter w-full md:mx-auto leading-7'>
                        In a study conducted by independent researchers with 270 middle school students,
                        <span className='font-bold'> Muzology improved math performance for 99% of students in just 4 weeks.</span> Eighty-seven percent (87%) of students improved
                        their initial math scores by 50 points or more.
                    </p>
                    <p className='font-lg text-[#4B5563] font-light text-left font-Inter w-full md:mx-auto leading-7'>
                        Across a series of studies, Muzology continues to drive increased and sustained learning gains for students throughout the country.
                    </p>
                    */}
                </div>
                <div className='w-full z-10 relative'>
                    <div className='w-full lg:w-auto m-auto lg:scale-[120%] flex items-center'>
                        <Image className='m-auto lg:m-0' data={{ ...featuredImage.responsiveImage, bgColor: '#00000000' }} priority={false} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TwoCol;
